<template>
  <AnalyticsChartWrapper
    ref="chartWrapper"
    :config="data"
    :horizontal="true"
    @titleChanged="changeHighChartsTitle"
    @captionChanged="changeHighChartsCaption"
  >
    <template slot="chart">
      <BarChart
        ref="chartRef"
        :chart="data"
        :exporting="{width: 1200, spacingRight: 325}"
        @adjustMenuIcon="adjustMenuIcon"
      />
    </template>
  </AnalyticsChartWrapper>
</template>

<script>
import AnalyticsChartWrapper from '@/components/analytics/outcomesExplorer/charts/AnalyticsChartWrapper'
import BarChart from '@/components/common/BarChart'
import { ChartChangesHelper } from '@/mixins/analytics/Charts/ChartChangesHelper'

export default {
  name: 'AnalyticsResultChartsOutcomesAdmissionVsDischarge',
  components: {
    BarChart,
    AnalyticsChartWrapper
  },
  mixins: [ChartChangesHelper],
  props: {
    programName: {
      type: String,
      default: ''
    },
    data: {}
  }
}
</script>
